export default "__VITE_ASSET__DLGzFqGl__"